import { render } from "./JFdefeated.vue?vue&type=template&id=e6f20d4c&scoped=true"
import script from "./JFdefeated.vue?vue&type=script&lang=js"
export * from "./JFdefeated.vue?vue&type=script&lang=js"

import "./JFdefeated.vue?vue&type=style&index=0&id=e6f20d4c&lang=scss&scoped=true"
import "./JFdefeated.vue?vue&type=style&index=1&id=e6f20d4c&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6f20d4c"]])

export default __exports__